import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

customerCardStyles.selectButton = {
    variant: "secondary",
    hoverMode: "none",
};

customerCardStyles.editLink = mergeToNew(customerCardStyles.editLink, {
    css: css`
        color: ${getColor("text.accent")};
        margin-top: 1rem;
    `,
});

customerCardStyles.container = {
    css: css`
        padding: 1rem 0;
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};
